/* eslint-disable indent */
import angular from 'angular';
import uiRouter from 'angular-ui-router';

import OrderAtTableDetailsComponent from './orderAtTable.component';

const OrderAtTableModule = angular.module('tinaba.components.services.orderAtTable', [
    uiRouter
])
.config(($stateProvider) => {
    'ngInject';
    $stateProvider.state('services.orderAtTable', {
        url: '/orderAtTable',
        template: '<order-at-table-details></order-at-table-details>'
    });
})
.component('orderAtTableDetails', OrderAtTableDetailsComponent);

export default OrderAtTableModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAtTable/orderAtTable.js
 **/